import { render, staticRenderFns } from "./PromotionsHelperMenu.vue?vue&type=template&id=70957787&scoped=true&"
import script from "./PromotionsHelperMenu.vue?vue&type=script&lang=js&"
export * from "./PromotionsHelperMenu.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsHelperMenu.vue?vue&type=style&index=0&id=70957787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70957787",
  null
  
)

export default component.exports